module.exports = __webpack_public_path__ + "media/audio/ambience/INTRO-AND-END-PAGES-ONE-SHOT.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/media/audio/ambience/INTRO-AND-END-PAGES-ONE-SHOT.mp3
// module id = 16
// module chunks = 0